export default __webpack_public_path__ + "static/media/hatha.26fc185f.png";